/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class AzureServicePrincipalIdResponse {
  /**
  * The management app service principal ID for Azure role assignments
  */
  'managementServicePrincipalId': string;
  /**
  * The data access app service principal ID for Azure role assignments
  */
  'dataAccessServicePrincipalId': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "managementServicePrincipalId",
      "baseName": "managementServicePrincipalId",
      "type": "string",
      "format": ""
    },
    {
      "name": "dataAccessServicePrincipalId",
      "baseName": "dataAccessServicePrincipalId",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AzureServicePrincipalIdResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

